import React from 'react';
import PropTypes from 'prop-types';
import {Button, Table} from 'react-bootstrap';
import FaTrash from 'react-icons/lib/fa/trash-o';
import {Link} from 'react-router-dom';
import TablePager from '../TablePager';

class ContactList extends React.Component {
  getTable = (contacts) => {
    return(
      <Table data-cy="contacts-table" responsive>
        <thead className="text-primary">
        <tr>
          <th>Name</th>
          <th>Email Address</th>
          <th>Phone Number</th>
          <th/>
        </tr>
        </thead>
        <tbody>
        {
          contacts && contacts.map((contact, i) => {
            return (
              <tr key={contact.id} className="contact">
                <td>
                  <Link to={`/companies/${contact.company_id}/contacts/${contact.id}`}>
                    {contact.first_name} {contact.last_name}
                  </Link>
                </td>
                <td>{contact.email}</td>
                <td>{contact.phone}</td>
                <td align="right">
                  <Button data-cy="delete-contact-button" className="primary" onClick={() => this.props.deleteContact(contact.id)}><FaTrash /></Button>
                </td>
              </tr>
            );
          })
        }

        </tbody>
      </Table>
    );
  }

  render() {
    return (
      <TablePager data={this.props.contacts} dataTable={this.getTable}/>
    );
  }
}


ContactList.propTypes = {
  contacts: PropTypes.array.isRequired,
  deleteContact: PropTypes.func
};

export default ContactList;


// WEBPACK FOOTER //
// ./src/components/contacts/ContactList.js